module.exports = __webpack_public_path__ + "static/media/uae_map.f310f098.svg";